<template>
  <div>
    <div class="px-3">
      <FilterWrapper>
        <template slot="filterForm">
          <GenericFilter
            :loading="loading"
            :rLoading="rLoading"
            :submitFilter="refetch"
            :clearFilter="() => clearFilter('refundRef')"
          />
        </template>
      </FilterWrapper>
    </div>
    <TableWrapper
      :loading="loading"
      :errorMsg="errorMsg"
      :refetch="fetchSubAccounts"
      :isEmpty="isEmpty"
      :emptyTitle="emptyTitle"
    >
      <div class="w-100 py-3" slot="content">
        <v-server-table
          ref="refundRef"
          class="v-table "
          :data="customers"
          :columns="columns"
          :options="options"
          @loaded="onLoaded"
          @row-click="handleClick"
        >
          <template slot="amount" slot-scope="{ row }">
            {{ toCurrency(row.amount, row.currency) }}
          </template>
          <template slot="charges" slot-scope="{ row }">
            {{ toCurrency(row.charges, row.currency) }}
          </template>
          <template slot="status" slot-scope="{ row }">
            <span :class="statusColor(row.status)">
              {{ titleCase(row.status) }}
            </span>
          </template>
          <template slot="createdAt" slot-scope="props">
            <span>
              {{
                timeDateFormat(props.row.createdAt).date +
                  " " +
                  timeDateFormat(props.row.createdAt).time
              }}
            </span>
          </template>
        </v-server-table>
      </div>
    </TableWrapper>
  </div>
</template>

<script>
import { componentData } from "../../../../../../public/assets/mixins/componentData";
import TableWrapper from "../../../../../components/utils/TableWrapper/TableWrapper.vue";
import GenericFilter from "../../../../../components/filters/GenericFilter.vue";

const plansHeadings = {
  original_transaction_reference: "Payment Reference",
  amount: "Amount",
  charges: "Charges",
  reference: "Refund Reference",
  createdAt: "Date",
  status: "Status",
};

export default {
  name: "Refund",
  mixins: [componentData],
  data() {
    return {
      singleInviteObj: null,
      showSingleInviteModal: false,
      emptyTitle: "No Refund Found",
      showInviteModal: false,
      loading: false,
      errorMsg: "",
      customers: [],
      ...this.tableOptions(plansHeadings, 25),
    };
  },
  components: {
    TableWrapper,
    GenericFilter,
  },
  methods: {
    refetch(filters) {
      this.handleRefetch(filters, this.fetchSubAccounts, "refundRef");
    },
    handleClick({ row }) {
      // this.$router.push(
      //   `/sub-account-details/${this.clientid}/${row.reference}`
      // );
    },
    async fetchSubAccounts() {
      this.options.requestFunction = async (data) => {
        const params = { ...data, ...this.filters, id: this.clientid };
        const response = await this.$store.dispatch(
          "customer/getPaymentMerchantRefunds",
          {
            params,
          }
        );

        const newData = response.data.data;
        const count = response.data.total;
        return { ...response, count, total: count, data: newData };
      };
    },
  },

  props: ["clientid"],
  created() {
    this.fetchSubAccounts();
  },
  mounted() {
    this.columns = Object.keys(plansHeadings).map((keyVal) => keyVal);
  },
};
</script>
